import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { createAppAction } from "../action/createAppAction";
import { getAllAppAction } from "../action/getAllAppAction";

const initialState: CreateAppData = {
  data: [],
  loading: false,
  error: null,
};

const getAllAppSlice = createSlice({
  name: "getAllAppSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAppAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAppAction.fulfilled, (state, action) => {
        //// console.log("action payload ---> ", action);
        state.loading = false;
        state.data = action.payload.result.result;
      })
      .addCase(getAllAppAction.rejected, (state, action) => {
        state.loading = false;
        //state.error = action.payload;
      });
  },
});

export const getAllAppReducer = getAllAppSlice.reducer;
